// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCkBTk01QEcR9MtDyLJLdyybgpPClP63ZY",
  authDomain: "trucking-web.firebaseapp.com",
  projectId: "trucking-web",
  storageBucket: "trucking-web.firebasestorage.app",
  messagingSenderId: "657178194465",
  appId: "1:657178194465:web:20f521a44b7c8ad203e960",
  measurementId: "G-DTEH6N93WE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Enable offline persistence for Firestore
enableIndexedDbPersistence(db)
  .then(() => {
    console.log("Offline persistence enabled");
  })
  .catch((err) => {
    console.error("Offline persistence error:", err);
  });

export default app;